import React from 'react';
import styled, { css } from 'styled-components';
import parse from 'html-react-parser';

import Text from '../shared/Text';
import { flexCenter, resultPalette } from '../../constants/styles';


const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Benefit = styled.div`
  ${flexCenter};
  align-items: flex-start;
  justify-content: flex-start;
`;

const StyledBulletContainer = styled.div`
  height: 20px;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

const StyledBullet = styled.div`
  height: 10px;
  width: 10px;
  margin: 0px;
  margin-top: 5px;
  margin-right: 10px;
  ${({ color }) => color && css`
    background-color: ${color};
  `}
`;

const Benefits = ({ entries }) => (
  <Container>
    {
      entries.map(entry => (
        entry.benefit && (
          <Benefit key={entry.benefit}>
            <StyledBulletContainer>
              <StyledBullet color={entry.color} />
            </StyledBulletContainer>
            <Text>
              { parse(entry.benefit) }
            </Text>

          </Benefit>
        )
      ))
    }
  </Container>
);

export default Benefits;
